import React from 'react';
import { Section } from './ui/Section';
import { useMetaPixelViewTracking, trackEvent } from '../utils/metaPixel';
export function Pricing() {
  // Track when pricing section is viewed
  useMetaPixelViewTracking('pricing', {
    content_category: 'pricing',
    content_type: 'product'
  });
  const baseFeatures = ['6 Tomos PDF (+480 páginas)', '6 Bonos de implementación', 'Acceso inmediato', 'PDF optimizado para móvil', 'Garantía 7 días'];
  const completeFeatures = [...baseFeatures, '🔥 Sistema Profesional para Instructoras de Zumba™ completo', '🔥 4 contratos legales firmables', '🔥 20 creativos Canva editables', '🔥 5 guiones de vídeo', '🔥 48 fichas imprimibles', '🔥 Plan 30 Días Sin Pensar'];
  const handlePackClick = (packName: string, price: string) => {
    trackEvent('InitiateCheckout', {
      content_name: packName,
      value: parseFloat(price),
      currency: 'EUR'
    });
  };
  return <Section id="pricing" variant="alt" data-id="element-240">
      <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-12 text-brand-title" data-id="element-241">
        💰 ELIGE TU PACK
      </h2>

      <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-8" data-id="element-242">
        {/* Base Pack */}
        <div className="bg-white border-[1.5px] border-brand-border rounded-2xl p-8 shadow-card hover:shadow-violet-glow transition-shadow" data-id="element-243">
          <div className="bg-brand-cardPeach rounded-xl p-4 mb-6 -mx-8 -mt-8" data-id="element-244">
            <div className="flex items-center gap-2" data-id="element-245">
              <span className="text-3xl" data-id="element-246">🥉</span>
              <div data-id="element-247">
                <h3 className="font-heading text-xl font-bold text-brand-text tracking-wide" data-id="element-248">
                  PACK BASE
                </h3>
              </div>
            </div>
          </div>

          <p className="font-body text-brand-textMuted mb-6 text-sm" data-id="element-249">
            El sistema completo para enseñar mejor desde hoy.
          </p>

          <div className="text-center text-sm text-brand-textMuted mb-4 md:hidden tracking-wide" data-id="element-250">
            ← Scroll to see full table →
          </div>

          <div className="overflow-x-auto mb-6" data-id="element-251">
            <table className="w-full min-w-[280px] border-collapse bg-brand-card/30 rounded-xl overflow-hidden border border-brand-border" data-id="element-252">
              <thead data-id="element-253">
                <tr className="border-b border-brand-border" data-id="element-254">
                  <th className="text-left p-3 font-heading font-bold text-brand-text text-sm tracking-wide uppercase" data-id="element-255">
                    ✅ Incluye
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-256">
                {baseFeatures.map((feature, i) => <tr key={i} className="border-b border-brand-border/30 last:border-0" data-id="element-257">
                    <td className="p-3 font-body text-brand-text text-sm flex items-start gap-2" data-id="element-258">
                      <span className="text-brand-success shrink-0" data-id="element-259">✅</span>
                      <span data-id="element-260">{feature}</span>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          <div className="text-center mb-6" data-id="element-261">
            <div className="font-body text-brand-textMuted text-sm mb-1 line-through" data-id="element-262">
              Valor real: 83,94€
            </div>
            <div className="font-display text-4xl font-black text-brand-title mb-4" data-id="element-263">
              14,90€
            </div>
          </div>

          <a href="https://www.digipromarket.com/cart/56761280299334:1" target="_blank" rel="noopener noreferrer" onClick={() => handlePackClick('Pack Base', '14.90')} className="font-heading w-full bg-gradient-gold hover:bg-brand-ctaHover text-white font-bold text-lg py-4 px-6 rounded-2xl transition-colors text-center block shadow-gold-glow mb-4 tracking-wide" data-id="element-264">
            🚀 QUIERO EL PACK BASE
          </a>

          <div className="text-center space-y-1 text-xs text-brand-textMuted tracking-wide" data-id="element-265">
            <div data-id="element-266">⚡ Acceso Inmediato</div>
            <div data-id="element-267">💳 Pago Único</div>
            <div data-id="element-268">🛡️ Garantía 7 Días</div>
          </div>
        </div>

        {/* Complete Pack */}
        <div className="bg-white border-[2.5px] border-brand-title rounded-2xl p-8 shadow-gold-glow-lg relative md:-translate-y-4" data-id="element-269">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-gradient-gold text-white font-heading font-bold px-4 py-1 rounded-full text-sm whitespace-nowrap shadow-gold-glow tracking-wider" data-id="element-270">
            ⭐ MÁS POPULAR
          </div>

          <div className="bg-gradient-gold rounded-xl p-4 mb-6 -mx-8 -mt-8" data-id="element-271">
            <div className="flex items-center gap-2" data-id="element-272">
              <span className="text-3xl" data-id="element-273">🥇</span>
              <div data-id="element-274">
                <h3 className="font-heading text-xl font-bold text-white tracking-wide" data-id="element-275">
                  PACK COMPLETO
                </h3>
              </div>
            </div>
          </div>

          <p className="font-body text-brand-textMuted mb-6 text-sm" data-id="element-276">
            Todo el Pack Base + el Sistema Profesional para Instructoras de
            Zumba™
          </p>

          <div className="text-center text-sm text-brand-textMuted mb-4 md:hidden tracking-wide" data-id="element-277">
            ← Scroll to see full table →
          </div>

          <div className="overflow-x-auto mb-6" data-id="element-278">
            <table className="w-full min-w-[280px] border-collapse bg-brand-card/30 rounded-xl overflow-hidden border border-brand-title/30" data-id="element-279">
              <thead data-id="element-280">
                <tr className="border-b border-brand-title/30" data-id="element-281">
                  <th className="text-left p-3 font-heading font-bold text-brand-text text-sm tracking-wide uppercase" data-id="element-282">
                    ✅ Incluye
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-283">
                {completeFeatures.map((feature, i) => <tr key={i} className="border-b border-brand-border/30 last:border-0" data-id="element-284">
                    <td className="p-3 font-body text-brand-text text-sm flex items-start gap-2" data-id="element-285">
                      <span className="text-brand-success shrink-0" data-id="element-286">✅</span>
                      <span data-id="element-287">{feature}</span>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          <div className="text-center mb-6" data-id="element-288">
            <div className="font-body text-brand-textMuted text-sm mb-1 line-through" data-id="element-289">
              Valor real: 147,94€
            </div>
            <div className="font-display text-5xl font-black text-brand-title mb-4" data-id="element-290">
              19,90€
            </div>
          </div>

          <a href="https://www.digipromarket.com/cart/56761287737670:1" target="_blank" rel="noopener noreferrer" onClick={() => handlePackClick('Pack Completo', '19.90')} className="font-heading w-full bg-gradient-gold hover:bg-brand-ctaHover text-white font-bold text-lg py-4 px-6 rounded-2xl transition-colors text-center block shadow-gold-glow mb-4 tracking-wide" data-id="element-291">
            🚀 QUIERO EL PACK COMPLETO
          </a>

          <div className="text-center space-y-1 text-xs text-brand-textMuted tracking-wide" data-id="element-292">
            <div data-id="element-293">⚡ Acceso Inmediato</div>
            <div data-id="element-294">💳 Pago Único</div>
            <div data-id="element-295">🛡️ Garantía 7 Días</div>
          </div>
        </div>
      </div>

      <div className="bg-white border border-brand-border rounded-2xl p-6 max-w-2xl mx-auto text-center shadow-card" data-id="element-296">
        <p className="font-body text-brand-text font-medium" data-id="element-297">
          💡 Por solo 5€ más tienes el sistema completo con todo ya creado. La
          gran mayoría elige este.
        </p>
      </div>
    </Section>;
}